export default "<div class=\"arrow-container previous text-center\" (click)=\"backClicked()\">\r\n    <i class=\"fas fa-chevron-left\"></i>\r\n</div>"